module.exports = __webpack_public_path__ + "dcc9afdf3cfc308c885442a3c7d193ac.MP3";